const calculateViewportUnits = () => {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
}

const calculateHeaderSize = () => {
    const header = document.querySelector('.l-header')
    const infoMessage = document.querySelector('.js-info-message')
    let headerHeight = 0

    if (header) {
        headerHeight += header.offsetHeight
    }

    if (infoMessage) {
        headerHeight += infoMessage.offsetHeight
    }

    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`)
}

export { calculateHeaderSize, calculateViewportUnits }
